<template>
    <div>
      <div class="bg">
        <div class="text-white text-right mr-5">
              <div class="col-12 pt-3">
                <h1 class="display-1"><strong>{{cliente}}</strong></h1>
                <h4>PORTAL DE OBRAS</h4>
              </div>
        </div>
          <div class="text-center botao-container">
            <a href="#status" class="btn btn-sm botao-status p-3 text-white"> VER STATUS DAS OBRAS<font-awesome-icon icon=arrow-down class="ml-2" /></a>
          </div>
      </div>
      <div class="container my-4 text-center">
        <main>
          <h2>BEM-VINDO AO PORTAL DE OBRAS</h2>
          <div class="row my-5">
            <div class="col-12 col-sm-5 text-justify">
              <p>
                O portal de Obras de Ibiúna é uma iniciativa da Prefeitura Municipal de Ibiúna, disponibilizando acesso livre  para consulta das Obras que estão sendo realizadas no município. Tem como objeto o acesso dos dados das obras para sociedade e outras esferas do governo, permitindo de forma intuitiva, flexível e rápida acessar informações referentes a valores de obras, cronogramas, fotos e documentos.
              </p>
              <div class="text-center mb-5 mapa">
                <b-link class="btn btn-md" href="/obras">VER OBRAS</b-link>
              </div>
            </div>
            <div class="col-12 col-sm-7">
              <b-img src='/static/img/pin-maps.png' fluid alt="Responsive image" width="300"></b-img>
            </div>
          </div>
        </main>
        
      </div>  
      <div class="bg-main">
        <div class="container" id="status">
          <h5>STATUS DAS OBRAS</h5>
          <div class="row">
            <div class="col-sm-2 mt-5" v-for="(obra, i) in obras" :key="i">
                <div class="col-sm-12 mt-5 bg-rounded"><br>
                    <h5 style="font-size:2em;"><strong>{{qtd[i]}}</strong></h5>
                    <p class="col-12 pt-5">{{obra.c04_descr}}</p>
                </div>
            </div>
          </div>
        </div>          
      </div>
    </div> 

</template>


<script>
import {mapState} from "vuex"

const axios = require('axios');

export default {
   name: 'MainInicio',
   data (){
     return {
      cliente: 'IBIÚNA',
      obras: [],
      dados: [],
      qtd: []
     }
   },
   computed: mapState(['api']),
   mounted (){
     axios
      .get(this.api+"obras-cidadao/situacoes")
      .then(response => {
        for(let i = 0; i < response.data.length && i < 6; i++){
          this.obras.push(response.data[i])
          axios
          .post(this.api+"obras-cidadao/situacoes/qtd", {
            id: response.data[i]
          })
          .then(response => {
            this.qtd.push(response.data)
          })
        }
        
    })
    
   } 
}

</script>

<style>

    .bg {
        background-image: url('/static/img/bg-header.png');
        background-repeat: no-repeat;
        background-size: cover;
        width: 100%;
        height: 420px;
    }

    .botao-container {
        margin-top: 150px;
    }
    .botao-container a{
      border-radius: 7px;
      font-weight: 500;
      background-color: #505a82;
    }
    
    .mapa a{
      color: #fff;
      border-radius: 7px;
      background-color:#505a82 !important;
    }
    .mapa a:hover, .botao-container a:hover {
      color: #fff;
      background-color: #404971 !important;
    }

    .bg-main {
        background-image: url('/static/img/bg-main.png');
        background-repeat: no-repeat;
        margin-top: -110px;
        width: 100%;
        background-size: cover;
        height: 350px;
    }

    .bg-rounded {
        height: 190px;
        border-radius: 100px;
        margin-top: 50px;
        text-align: center;
        background: #fff;
        color: #333;
    }
    @media screen and (max-width: 1170px) {
      h1,h4 {
        text-shadow: 0.1em 0.1em 0.2em black
      }

      
    }
     @media screen and (max-width: 992px) {
      .bg-main {
        display: none;
      }
      
      
    }

</style>




// WEBPACK FOOTER //
// src/components/pagina-inicial/MainInicio.vue